import React from 'react';
import { motion } from 'framer-motion';

export const SegmentedTabs = ({ value, onChange, options, testid = 'segmented' }) => {
  return (
    <div data-testid={testid} className="inline-flex rounded-2xl bg-secondary p-1 gap-1 w-full overflow-x-auto no-scrollbar">
      {options.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            data-testid={`${testid}-${opt.value}`}
            onClick={() => onChange(opt.value)}
            className={`relative px-4 py-1.5 rounded-xl text-sm font-medium transition-colors whitespace-nowrap flex-1 ${
              active ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {active && <motion.span layoutId={`${testid}-pill`} transition={{ duration: 0.22 }} className="absolute inset-0 bg-card rounded-xl shadow-sm border border-border" />}
            <span className="relative">{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
};
